// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import {
//   registerAction,
//   updatePhoneNumberAction,
// } from "../redux/auth/auth.actions";
// import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
// import { auth } from "../firebase"; // Make sure this path is correct

// export default function VerifyMobileOtp() {
//   const length = 6;
//   const [otp, setOtp] = useState(new Array(length).fill(""));
//   const inputRefs = useRef([]);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { confirmationResult, isLoading } = useSelector(
//     (state) => state.authInfo
//   );
//   const [resendDisabled, setResendDisabled] = useState(false);
//   const [isVerifying, setIsVerifying] = useState(false);
//   const [currentLanguage, setCurrentLanguage] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   // Add state for countdown timer
//   const [countdown, setCountdown] = useState(0);
//   // Timer reference for cleanup
//   const timerRef = useRef(null);

//   useEffect(() => {
//     const initializeRecaptcha = async () => {
//       const registerData = JSON.parse(localStorage.getItem("registerData"));
//       if (!window.recaptchaVerifier) {
//         window.recaptchaVerifier = new RecaptchaVerifier(
//           auth,
//           "recaptcha-container",
//           {
//             size: "invisible",
//             callback: (response) => {
//               // Handle reCAPTCHA solved callback
//             },
//             "expired-callback": () => {
//               // Handle reCAPTCHA expired callback
//             },
//           }
//         );
//         try {
//           const confirmationResult = await signInWithPhoneNumber(
//             auth,
//             `${registerData.countryCode}${registerData.phone}`,
//             window.recaptchaVerifier
//           );
//           window.confirmationResult = confirmationResult;
//           setOtpSent(true);
//           toast.success(
//             currentLanguage === "Italian"
//               ? "OTP inviato con successo!"
//               : "OTP sent successfully!"
//           );
//         } catch (error) {
//           console.error("Error during phone number sign-in:", error);
//           handleFirebaseError(error);
//         }

//         // Ensure the reCAPTCHA container exists before rendering
//         const recaptchaContainer = document.getElementById(
//           "recaptcha-container"
//         );
//         if (recaptchaContainer) {
//           window.recaptchaVerifier.render().catch((err) => {
//             console.error("Error rendering reCAPTCHA", err);
//           });
//         } else {
//           console.error("reCAPTCHA container not found");
//         }
//       }
//     };

//     setCurrentLanguage(localStorage.getItem("language"));
//     if (inputRefs.current[0]) {
//       inputRefs.current[0].focus();
//     }
//     initializeRecaptcha();
//   }, [location.state]);

//   // Firebase error handler function - just display messages without changing timer
//   const handleFirebaseError = (error) => {
//     console.error("Firebase error:", error);

//     // Handle different Firebase error codes
//     switch (error.code) {
//       case "auth/too-many-requests":
//         toast.error(
//           currentLanguage === "Italian"
//             ? "Troppe richieste. Per favore riprova più tardi."
//             : "Too many attempts. Please try again later."
//         );
//         break;
//       case "auth/quota-exceeded":
//         toast.error(
//           currentLanguage === "Italian"
//             ? "Quota superata. Per favore riprova più tardi."
//             : "Quota exceeded. Please try again later."
//         );
//         break;
//       case "auth/invalid-phone-number":
//         toast.error(
//           currentLanguage === "Italian"
//             ? "Numero di telefono non valido. Controlla e riprova."
//             : "Invalid phone number. Please check and try again."
//         );
//         break;
//       case "auth/captcha-check-failed":
//         toast.error(
//           currentLanguage === "Italian"
//             ? "Verifica captcha fallita. Ricarica la pagina e riprova."
//             : "Captcha check failed. Please reload the page and try again."
//         );
//         // Reset recaptcha
//         if (window.recaptchaVerifier) {
//           window.recaptchaVerifier.clear();
//           window.recaptchaVerifier = null;
//         }
//         break;
//       default:
//         toast.error(
//           currentLanguage === "Italian"
//             ? "Impossibile inviare OTP. Per favore riprova."
//             : "Failed to send OTP. Please try again."
//         );
//     }
//   };

//   // Effect for countdown timer
//   useEffect(() => {
//     if (countdown > 0) {
//       timerRef.current = setTimeout(() => {
//         setCountdown(countdown - 1);
//       }, 1000);
//     } else if (countdown === 0 && resendDisabled) {
//       setResendDisabled(false);
//     }

//     // Cleanup timeout on unmount or when countdown changes
//     return () => {
//       if (timerRef.current) {
//         clearTimeout(timerRef.current);
//       }
//     };
//   }, [countdown, resendDisabled]);

//   const handleChange = (index, e) => {
//     const value = e.target.value.replace(/\D/, "");
//     if (!value) return;

//     const newOtp = [...otp];
//     newOtp[index] = value.charAt(0);
//     setOtp(newOtp);

//     if (index < length - 1 && inputRefs.current[index + 1]) {
//       inputRefs.current[index + 1].focus();
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace") {
//       const newOtp = [...otp];
//       if (otp[index]) {
//         newOtp[index] = "";
//       } else if (index > 0) {
//         newOtp[index - 1] = "";
//         inputRefs.current[index - 1].focus();
//       }
//       setOtp(newOtp);
//     }
//   };

//   const handleResendOtp = async () => {
//     if (resendDisabled) return;

//     try {
//       setResendDisabled(true);
//       // Start the 60-second countdown
//       setCountdown(60);

//       // Clear OTP fields
//       setOtp(new Array(length).fill(""));
//       // Focus on first input
//       if (inputRefs.current[0]) {
//         inputRefs.current[0].focus();
//       }

//       const registerData = JSON.parse(localStorage.getItem("registerData"));
//       if (!registerData || !registerData.phone) {
//         toast.error(
//           currentLanguage === "Italian"
//             ? "Numero di telefono non trovato! Riprova."
//             : "Phone number not found! Try again."
//         );
//         // Keep the timer running even in case of this error
//         return;
//       }

//       if (location.state?.from !== "/auth/reset-password") {
//         toast.info(
//           currentLanguage === "Italian" ? "Reinvio OTP..." : "Resending OTP..."
//         );
//       }

//       // Use the already initialized reCAPTCHA verifier
//       let recaptchaVerifier = window.recaptchaVerifier;

//       // If there's no recaptcha verifier, create a new one
//       if (!recaptchaVerifier) {
//         window.recaptchaVerifier = new RecaptchaVerifier(
//           auth,
//           "recaptcha-container",
//           {
//             size: "invisible",
//             callback: () => {},
//             "expired-callback": () => {},
//           }
//         );
//         recaptchaVerifier = window.recaptchaVerifier;
//       }

//       // Send OTP using Firebase
//       const newConfirmationResult = await signInWithPhoneNumber(
//         auth,
//         `${registerData.countryCode}${registerData.phone}`,
//         recaptchaVerifier
//       );
//       window.confirmationResult = newConfirmationResult;
//       setOtpSent(true);
//       toast.success(
//         currentLanguage === "Italian"
//           ? "OTP inviato con successo!"
//           : "OTP sent successfully!"
//       );
//     } catch (error) {
//       console.error("Error resending OTP:", error);
//       // Display Firebase error messages without affecting the timer
//       handleFirebaseError(error);
//       // Timer continues to run - we don't reset resendDisabled here
//     }
//   };

//   const handleVerify = async () => {
//     const enteredOtp = otp.join("");
//     if (enteredOtp.length !== length) {
//       toast.error(
//         currentLanguage === "Italian"
//           ? "Inserisci un OTP valido di 6 cifre."
//           : "Enter a valid 6-digit OTP."
//       );
//       return;
//     }

//     try {
//       setIsVerifying(true);
//       // Get the confirmation result from window or Redux
//       const localConfirmationResult =
//         window.confirmationResult || confirmationResult;

//       if (!localConfirmationResult) {
//         toast.error(
//           currentLanguage === "Italian"
//             ? "Sessione di verifica scaduta. Per favore riprova."
//             : "Verification session expired. Please try again."
//         );
//         setIsVerifying(false);
//         return;
//       }

//       // Verify the OTP using Firebase
//       const credential = await localConfirmationResult.confirm(enteredOtp);

//       if (credential && credential.user) {
//         toast.success(
//           currentLanguage === "Italian"
//             ? "Numero di cellulare verificato con successo!"
//             : "Mobile number verified successfully!"
//         );
//         if (location.state?.from === "/auth/forget-password") {
//           navigate("/auth/reset-password");
//         } else if (location.state?.from === "getPhone") {
//           dispatch(
//             updatePhoneNumberAction(
//               JSON.parse(localStorage.getItem("registerData"))
//             )
//           );
//           navigate("/sondaggi");
//         } else {
//           dispatch(
//             registerAction(JSON.parse(localStorage.getItem("registerData")))
//           );
//           navigate("/auth/verify-otp");
//         }
//       } else {
//         toast.error(
//           currentLanguage === "Italian"
//             ? "OTP errato. Per favore riprova."
//             : "Wrong OTP. Please try again."
//         );
//       }
//       setIsVerifying(false);
//     } catch (error) {
//       console.error("Firebase OTP verification error:", error);

//       if (error.code === "auth/invalid-verification-code") {
//         toast.error(
//           currentLanguage === "Italian"
//             ? "OTP errato. Per favore riprova."
//             : "Wrong OTP. Please try again."
//         );
//       } else if (error.code === "auth/code-expired") {
//         toast.error(
//           currentLanguage === "Italian"
//             ? "OTP scaduto. Per favore richiedine uno nuovo."
//             : "OTP has expired. Please request a new one."
//         );
//       } else {
//         toast.error(
//           currentLanguage === "Italian"
//             ? "Verifica fallita. Per favore riprova."
//             : "Verification failed. Please try again."
//         );
//       }
//       setIsVerifying(false);
//     }
//   };

//   useEffect(() => {
//     const state = location.state;
//     if (state && state.phone && state.countryCode && !otpSent) {
//       const registerData = {
//         phone: state.phone,
//         countryCode: state.countryCode,
//       };
//       localStorage.setItem("registerData", JSON.stringify(registerData));
//       // handleResendOtp();
//     }
//   }, [location.state, otpSent]);

//   return (
//     <>
//       <div className="verify_code">
//         <div className="top_text">
//           {currentLanguage === "Italian"
//             ? "Inserisci il codice di verifica a 6 cifre inviato al tuo numero di cellulare."
//             : "Enter the 6-digit verification code sent to your mobile."}
//         </div>
//         <div className="otp_container">
//           {otp.map((digit, index) => (
//             <input
//               key={index}
//               type="tel"
//               inputMode="numeric"
//               pattern="[0-9]*"
//               maxLength="1"
//               value={digit}
//               onChange={(e) => handleChange(index, e)}
//               onKeyDown={(e) => handleKeyDown(index, e)}
//               ref={(el) => (inputRefs.current[index] = el)}
//               className="otp_input"
//               placeholder="•"
//               disabled={isLoading || isVerifying}
//             />
//           ))}
//         </div>
//         <div className="action mb15">
//           <button
//             onClick={handleVerify}
//             disabled={isLoading || isVerifying}
//             className={isLoading || isVerifying ? "loading-btn" : ""}
//           >
//             {isLoading || isVerifying ? (
//               <>
//                 <span className="loading-spinner"></span>
//                 <span>
//                   {currentLanguage === "Italian"
//                     ? "Verifica in corso..."
//                     : "Verifying..."}
//                 </span>
//               </>
//             ) : currentLanguage === "Italian" ? (
//               "Verifica"
//             ) : (
//               "Verify"
//             )}
//           </button>
//         </div>
//         <div className="have_account">
//           {currentLanguage === "Italian"
//             ? "Non hai ricevuto?"
//             : "Didn't receive?"}{" "}
//           <button
//             onClick={handleResendOtp}
//             disabled={isLoading || resendDisabled || isVerifying}
//           >
//             {resendDisabled && countdown > 0 ? (
//               <span>
//                 {currentLanguage === "Italian"
//                   ? `Riprova in ${countdown}s`
//                   : `Resend in ${countdown}s`}
//               </span>
//             ) : currentLanguage === "Italian" ? (
//               "Reinvia"
//             ) : (
//               "Resend"
//             )}
//           </button>
//         </div>
//         <div id="recaptcha-container"></div>
//       </div>
//     </>
//   );
// }

//  New Logic
// Firebase-related imports removed
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  registerAction,
  updatePhoneNumberAction,
  sendOtpAction,
  verifyOtpActionForPhone,
  getProfileDataAction
} from "../redux/auth/auth.actions";

export default function VerifyMobileOtp() {
  const OTP_LENGTH = 6;
  const RESEND_TIMEOUT = 60;

  const [otp, setOtp] = useState(new Array(OTP_LENGTH).fill(""));
  const inputRefs = useRef([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading } = useSelector((state) => state.authInfo);

  const [resendDisabled, setResendDisabled] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState("");
  const [countdown, setCountdown] = useState(0);
  const timerRef = useRef(null);

  // Extract data from location state
  const { phone, countryCode, from, surveyId } = location.state || {};

  // Load language and focus first input on component mount
  useEffect(() => {
    const lang = localStorage.getItem("language") || "English";
    setCurrentLanguage(lang);

    // Send OTP on initial load
    if (phone && countryCode && !resendDisabled) {
      handleSendOtp();
    }

    // Focus first input
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  // Handle countdown timer for resend functionality
  useEffect(() => {
    if (countdown > 0) {
      timerRef.current = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0 && resendDisabled) {
      setResendDisabled(false);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [countdown, resendDisabled]);

  // Save user data to localStorage
  useEffect(() => {
    if (phone && countryCode) {
      const registerData = {
        phone,
        countryCode
      };
      localStorage.setItem("registerData", JSON.stringify(registerData));
    }
  }, [phone, countryCode]);

  // Handle OTP input change
  const handleChange = (index, e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only digits
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value.charAt(0);
    setOtp(newOtp);

    // Auto-focus next input
    if (index < OTP_LENGTH - 1 && value) {
      inputRefs.current[index + 1].focus();
    }
  };

  // Handle backspace and arrow key navigation
  const handleKeyDown = (index, e) => {
    switch (e.key) {
      case "Backspace":
        if (otp[index]) {
          // Clear current input if it has value
          const newOtp = [...otp];
          newOtp[index] = "";
          setOtp(newOtp);
        } else if (index > 0) {
          // Move to previous input if current is empty
          const newOtp = [...otp];
          newOtp[index - 1] = "";
          setOtp(newOtp);
          inputRefs.current[index - 1].focus();
        }
        break;
      case "ArrowLeft":
        if (index > 0) {
          inputRefs.current[index - 1].focus();
        }
        break;
      case "ArrowRight":
        if (index < OTP_LENGTH - 1) {
          inputRefs.current[index + 1].focus();
        }
        break;
      default:
        break;
    }
  };

  // Handle paste event for OTP
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain").trim();

    // Check if pasted content is numeric and of correct length
    if (/^\d+$/.test(pastedData)) {
      const digits = pastedData.slice(0, OTP_LENGTH).split("");
      const newOtp = [...otp];

      digits.forEach((digit, idx) => {
        if (idx < OTP_LENGTH) {
          newOtp[idx] = digit;
        }
      });

      setOtp(newOtp);

      // Focus the appropriate input
      if (digits.length < OTP_LENGTH) {
        inputRefs.current[digits.length].focus();
      } else {
        inputRefs.current[OTP_LENGTH - 1].focus();
        // Auto-submit when all fields are filled via paste
        setTimeout(() => handleVerify(), 300);
      }
    }
  };

  // Send OTP
  const handleSendOtp = async () => {
    try {
      setResendDisabled(true);
      setCountdown(RESEND_TIMEOUT);
      setOtp(new Array(OTP_LENGTH).fill(""));

      // Focus first input after clearing
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }

      const registerData = JSON.parse(localStorage.getItem("registerData"));
      if (!registerData || !registerData.phone) {
        toast.error(
          currentLanguage === "Italian"
            ? "Numero di telefono non trovato! Riprova."
            : "Phone number not found! Try again."
        );
        return;
      }

      // Dispatch the send OTP action
      await dispatch(sendOtpAction(registerData));

    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error(
        currentLanguage === "Italian"
          ? "Errore nell'invio dell'OTP. Riprova."
          : "Error sending OTP. Please try again."
      );
      setResendDisabled(false);
    }
  };

  // Verify OTP
  const handleVerify = async () => {
    const enteredOtp = otp.join("");

    if (enteredOtp.length !== OTP_LENGTH) {
      toast.error(
        currentLanguage === "Italian"
          ? `Inserisci un OTP valido di ${OTP_LENGTH} cifre.`
          : `Enter a valid ${OTP_LENGTH}-digit OTP.`
      );
      return;
    }

    try {
      setIsVerifying(true);

      const registerData = JSON.parse(localStorage.getItem("registerData"));
      if (!registerData) {
        toast.error(
          currentLanguage === "Italian"
            ? "Dati di registrazione non trovati. Riprova."
            : "Registration data not found. Please try again."
        );
        setIsVerifying(false);
        return;
      }

      // Add OTP to the request data
      const verifyData = {
        ...registerData,
        otp: enteredOtp
      };

      // Dispatch verify OTP action
      await dispatch(verifyOtpActionForPhone(verifyData));

      // Handle navigation based on where the user came from
      if (from === "/auth/forget-password") {
        navigate("/auth/reset-password");
      } else if (from === "/getPhone") {
        await dispatch(updatePhoneNumberAction(registerData));
        // Refresh profile data to ensure phone number is updated
        dispatch(getProfileDataAction());
        navigate(`/survey-details/${surveyId}`);
      } else {
        await dispatch(registerAction(registerData));
        // After phone verification during registration, fetch profile data
        dispatch(getProfileDataAction());
        navigate("/auth/verify-otp");
      }

    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error(
        currentLanguage === "Italian"
          ? "Verifica fallita. Per favore riprova."
          : "Verification failed. Please try again."
      );
    } finally {
      setIsVerifying(false);
    }
  };

  // Get translated text based on current language
  const getTranslation = (enText, itText) => {
    return currentLanguage === "Italian" ? itText : enText;
  };

  return (
    <div className="verify_code">
      <div className="top_text">
        {getTranslation(
          "Enter the 6-digit verification code that we will send to your mobile phone in 20 seconds.",
          "Inserisci il codice di verifica a 6 cifre che invieremo al tuo cellulare tra 20 secondi."
        )}
      </div>
      <div className="otp_container" onPaste={handlePaste}>
        {otp.map((digit, index) => (
          <input
            key={index}
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength="1"
            value={digit}
            onChange={(e) => handleChange(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            ref={(el) => (inputRefs.current[index] = el)}
            className="otp_input"
            placeholder="•"
            disabled={isLoading || isVerifying}
            aria-label={`Digit ${index + 1}`}
          />
        ))}
      </div>

      <div className="action mb15">
        <button
          onClick={handleVerify}
          disabled={isLoading || isVerifying || otp.some(digit => digit === "")}
          className={`verify-btn ${(isLoading || isVerifying) ? "loading-btn" : ""}`}
        >
          {isLoading || isVerifying ? (
            <>
              <span className="loading-spinner"></span>
              <span>
                {getTranslation("Verifying...", "Verifica in corso...")}
              </span>
            </>
          ) : (
            getTranslation("Verify", "Verifica")
          )}
        </button>
      </div>

      <div className="have_account">
        {getTranslation("Didn't receive?", "Non hai ricevuto?")} {" "}
        <button
          onClick={handleSendOtp}
          disabled={isLoading || resendDisabled || isVerifying}
          className="resend-btn"
        >
          {resendDisabled && countdown > 0 ? (
            <span>
              {getTranslation(
                `Resend in ${countdown}s`,
                `Riprova in ${countdown}s`
              )}
            </span>
          ) : (
            getTranslation("Resend", "Reinvia")
          )}
        </button>
      </div>
    </div>
  );
}